// 简单的 SEO meta 设置：title / keywords / description
// 在各页面 mounted 中调用；预渲染时 puppeteer 会在 mounted 之后抓取，meta 已写入 <head>
export function setSeo({ title, keywords, description } = {}) {
  if (title) document.title = title;
  if (keywords) upsertMeta("keywords", keywords);
  if (description) upsertMeta("description", description);
}

function upsertMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
